import { useCustomUpdateDailyFormVehiclePartMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useUpdateDailyFormVehiclePart() {
  const [mutation, { loading, data, error }] = useCustomUpdateDailyFormVehiclePartMutation();

  const [updateDailyFormVehiclePart, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "updateDailyFormVehiclePart",
    },
    { hideMessage: true }
  );

  return [updateDailyFormVehiclePart, context] as const;
}
